import { gql, useSubscription } from '@apollo/client';
import { ChatMessage } from '@app/hooks/types';

export const AUDIT_CHAT_STREAM_SUBSCRIPTION = gql`
  subscription OnAuditChatStream($chatId: String!) {
    auditChatStream(chatId: $chatId) {
      role
      content
    }
  }
`;

interface AuditChatStreamSubscriptionResult {
  auditChatStream: ChatMessage;
}

interface AuditChatStreamSubscriptionVariables {
  chatId: string;
}

export const useAuditChatStreamSubscription = ({ chatId, onData }: { chatId: string; onData: () => void }) => {
  return useSubscription<AuditChatStreamSubscriptionResult, AuditChatStreamSubscriptionVariables>(
    AUDIT_CHAT_STREAM_SUBSCRIPTION,
    {
      variables: {
        chatId,
      },
      // onData,
    }
  );
};
